function createUploadDropzone(input, subtitle) {
  if (!input || input.dataset.wbDropzoneBound === '1') {
    return;
  }

  input.dataset.wbDropzoneBound = '1';

  const dropzone = document.createElement('button');
  dropzone.type = 'button';
  dropzone.className = 'wb-upload-dropzone';
  dropzone.innerHTML = `
    <span class="wb-upload-dropzone__icon" aria-hidden="true">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path d="M14 19V9M9 14h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
      </svg>
    </span>
    <span class="wb-upload-dropzone__title">Перетащите файлы сюда или выберите на устройстве</span>
    <span class="wb-upload-dropzone__subtitle">${subtitle}</span>
  `;

  dropzone.addEventListener('click', () => {
    input.click();
  });

  input.parentNode.insertBefore(dropzone, input);
  input.classList.add('wb-upload-input-hidden');
}

const wbUploadTargets = [
  {
    wrap: '.js-images-upload',
    input: '.js-image-upload-input-crop, .js-images-upload-input, .upload-image-input',
    subtitle: 'Загрузите обложку и дополнительные материалы работы',
  },
  {
    wrap: '.js-videos-upload',
    input: '.js-videos-upload-input',
    subtitle: 'Загрузите видеофайлы работы',
  },
  {
    wrap: '.js-audios-upload',
    input: '.js-audios-upload-input',
    subtitle: 'Загрузите аудиофайлы работы',
  },
  {
    wrap: '.js-documents-upload',
    input: '.js-documents-upload-input',
    subtitle: 'Загрузите документы работы',
  },
  {
    wrap: '.js-anyfile-upload',
    input: '.js-anyfile-upload-input',
    subtitle: 'Загрузите файлы',
  },
];

export function bindWbUploadDropzones(root = document) {
  if (!document.body.classList.contains('wb-embed')) {
    return;
  }

  wbUploadTargets.forEach(({ wrap, input, subtitle }) => {
    root.querySelectorAll(wrap).forEach((fieldset) => {
      const fileInput = fieldset.querySelector(input);

      if (fileInput) {
        createUploadDropzone(fileInput, subtitle);
      }
    });
  });
}

export default function initWbEmbedUi() {
  if (!document.body.classList.contains('wb-embed')) {
    return;
  }

  bindWbUploadDropzones();
}
